const translations: Record<string, string> = {
  "ak_bud3_mwh": "{{v}} MWh",
};

export default translations;
